
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bcxcq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $be68d709bad10db5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $be68d709bad10db5$export$2e2bcd8739ae039 = {
    'confluence-analytics-chart.default-loading-text': 'Refreshing analytics data...',
    'confluence-analytics-chart.tooltip.no-views-data': 'No data',
    'confluence-analytics-chart.tooltip.views-overall': '{count, plural, one {1 view} other {{count} views}}',
    'confluence-analytics-chart.tooltip.views-today-so-far': '{count, plural, one {1 view so far} other {{count} views so far}}',
    'confuence-analytics-chart.accessible-table.caption': 'Page views',
    'confuence-analytics-chart.accessible-table.header.date': 'Date',
    'confuence-analytics-chart.accessible-table.header.view-count': 'Views',
    'confuence-analytics-chart.accessible-table.no-view-count-data': 'No views'
};

});


//# sourceMappingURL=en.6e2e2da5.js.map
